// Opening a 1-2-1 space by hand (owner only): stage 4's small form under /admin (src/admin/OpenSpace.jsx),
// taken over by People at stage 5, in admin's look and with stage 4's approved words. client-space
// opens it, making the client's people row if they're new to the hub; nothing is emailed. On a person's
// page the same dialog opens with their email filled in.
//
// Which product (the product-types plan, 13 Oct): every private client space product that's live, less
// those this person already has an open space on (openProductIds). With 1 live client-space product in
// all, as today, it's exactly as before: no picker, the same words, and no product_id sent. With 2 or more
// live, product_id is always sent (client-space opens on that product only), and with 2 or more to pick
// from there's a "Which product" select, nothing picked until Adam picks. Every link opens the space on
// its own product's path.
import { useState } from 'react'
import { Button, ButtonLink, Dialog, Field, TextInput, Select, useAction, useAdmin } from '../ui/index.js'
import { COPY } from '../../products/mentorship/copy.js'
import { spacePath } from '../../products/mentorship/model.js'
import { PEOPLE } from './words.js'

const MENTORSHIP = { path: '/mentorship' }

// The live private client space products, in the catalogue's order
export const liveSpaceProducts = products => (products || [])
  .filter(p => p.type === 'client_space' && p.state === 'live' && p.moved_in !== false)

export function OpenSpaceDialog({ person, openProductIds = [], onClose, onOpened }) {
  const { api, products } = useAdmin()
  const live = liveSpaceProducts(products)
  const choices = live.filter(p => !openProductIds.includes(p.id))
  const [email, setEmail] = useState(person?.email || '')
  const [name, setName] = useState('')
  const [link, setLink] = useState('')
  const [picked, setPicked] = useState(choices.length === 1 ? choices[0].id : '')
  const [pickError, setPickError] = useState(null)
  const open = useAction(body => api.client_space(body))
  const product = live.find(p => p.id === picked) || (live.length === 1 ? live[0] : null)
  const where = product || MENTORSHIP

  async function submit(e) {
    e.preventDefault()
    if (live.length > 1 && !picked) { setPickError(PEOPLE.spaceProductNeeded); return }
    setPickError(null)
    const body = { action: 'open', email: email.trim() }
    if (!person && name.trim()) body.full_name = name.trim()
    if (link.trim()) body.booking_url = link.trim()
    if (live.length > 1) body.product_id = picked
    const answer = await open.run(body)
    if (answer) onOpened?.(answer)
  }

  const done = open.answer
  const already = open.error?.code === 'already_open' ? open.error.body?.space_id : null
  return (
    <Dialog title={COPY.openH2} onClose={onClose} busy={open.busy}
      footer={done
        ? <ButtonLink kind="ink" to={spacePath(where, done.space?.id)}>{done.person?.full_name ? COPY.openSpaceLink(done.person.full_name.split(' ')[0]) : COPY.openTheirSpace}</ButtonLink>
        : <Button kind="ink" type="submit" form="apl-open-space" busy={open.busy} busyLabel={COPY.opening}>{COPY.openButton}</Button>}>
      {done
        ? <p className="ad-lede" role="status">{done.message}</p>
        : (
          <form id="apl-open-space" className="ad-form" onSubmit={submit} noValidate>
            <p className="ad-lede">{COPY.openLine}</p>
            {live.length > 1 && choices.length > 1 && (
              <Field label={PEOPLE.spaceProduct} plain error={pickError}>
                {props => <Select {...props} value={picked} onChange={v => { setPicked(v); setPickError(null) }} placeholder={PEOPLE.spaceProductPick}
                  options={choices.map(p => ({ value: p.id, label: p.name }))} />}
              </Field>
            )}
            {live.length > 1 && choices.length === 1 && <p className="apl-hint">{PEOPLE.spaceProductOnly(choices[0].name)}</p>}
            {!person && (
              <Field label={COPY.openEmail} plain>
                {props => <TextInput {...props} type="email" value={email} onChange={setEmail} autoComplete="off" />}
              </Field>
            )}
            {!person && (
              <Field label={COPY.openName} hint={COPY.openNameHint} plain>
                {props => <TextInput {...props} value={name} onChange={setName} autoComplete="off" maxLength={120} />}
              </Field>
            )}
            <Field label={COPY.openLink} hint={COPY.openLinkHint} plain>
              {props => <TextInput {...props} type="url" inputMode="url" value={link} onChange={setLink} autoComplete="off" />}
            </Field>
            {open.error && (
              <p className="ad-error" role="alert">
                {open.error.message}
                {already && <> <ButtonLink size="xs" to={spacePath(where, already)}>{COPY.openTheirSpace}</ButtonLink></>}
              </p>
            )}
          </form>
        )}
    </Dialog>
  )
}
